import { TablePlusColorsKeys } from '@sketchnote/table';
import {
  ELEMENT_OL,
  ELEMENT_UL,
  findNode,
  insertNodes,
  PlateEditor,
  setNodes,
  toggleMark,
  toggleNodeType,
} from '@udecode/plate';
import { useCallback } from 'react';
import { Editor, Node, Path, Transforms } from 'slate';
import { v4 as uuidv4 } from 'uuid';
import { v4 as uuid } from 'uuid';

import { ELEMENT_BOARD } from '../../board';
import { useComboboxIsOpen, useComboBoxStore } from '../../combobox';
import { toggleList } from '../../list';
import { ELEMENT_TABLE_PLUS } from '../../table-plus';
import { getRandomArrayElement } from '../../utils';

export const useSlashOnSelectItem = () => {
  const isOpen = useComboboxIsOpen();
  const targetRange = useComboBoxStore((state) => state.targetRange);
  const closeMenu = useComboBoxStore((state) => state.closeMenu);

  return useCallback(
    (editor: Editor & PlateEditor, item) => {
      try {
        if (isOpen && targetRange) {
          Transforms.insertText(editor as any, '', {
            at: targetRange,
          });
          const [match] = Editor.nodes(editor, {
            match: (n: any) => Editor.isBlock(editor, n),
          });
          const path = match?.[1] || [editor.children.length - 1];
          const node = findNode(editor, { at: path })?.[0];
          const content = node ? Node.string(node) : '';
          if (item.type === ELEMENT_TABLE_PLUS) {
            if (content.length > 0) {
              insertNodes(
                editor,
                {
                  type: ELEMENT_TABLE_PLUS,
                  children: [{ text: '' }],
                  column: tablePlusData.columns,
                  row: tablePlusData.rows,
                },
                { at: Path.next(path) }
              );
            } else {
              setNodes(
                editor,
                {
                  type: ELEMENT_TABLE_PLUS,
                  children: [{ text: '' }],
                  column: tablePlusData.columns,
                  row: tablePlusData.rows,
                },
                { at: path }
              );
            }
          } else if (item.type === ELEMENT_BOARD) {
            if (content.length > 0) {
              insertNodes(
                editor,
                {
                  type: ELEMENT_BOARD,
                  children: [{ text: '' }],
                  columns: boardData.columns,
                },
                { at: Path.next(path) }
              );
            } else {
              setNodes(
                editor,
                {
                  type: ELEMENT_BOARD,
                  children: [{ text: '' }],
                  columns: boardData.columns,
                },
                { at: path }
              );
            }
          } else if (item.type === ELEMENT_UL || item.type === ELEMENT_OL) {
            toggleList(editor, { type: item.type });
          } else {
            if (item.isMark) {
              toggleMark(editor, item.type);
            } else {
              toggleNodeType(editor, { activeType: item.type || 'p' });
            }
          }

          return closeMenu();
        }
      } catch (error) {
        console.log(error);
      }
    },
    [closeMenu, isOpen, targetRange]
  );
};

const tablePlusData = {
  get columns() {
    return [
      {
        key: uuidv4(),
        type: 'text',
        name: 'Name',
        color: getRandomArrayElement(TablePlusColorsKeys),
        width: 300,
      },
      {
        key: uuidv4(),
        type: 'text',
        name: 'Tags',
        color: getRandomArrayElement(TablePlusColorsKeys),
        width: 300,
      },
      {
        key: uuidv4(),
        type: 'text',
        name: 'Versions',
        width: 300,
        color: getRandomArrayElement(TablePlusColorsKeys),
      },
    ];
  },

  get rows() {
    return [{ id: uuidv4() }, { id: uuidv4() }, { id: uuidv4() }];
  },
};

const boardData = {
  get columns() {
    return [
      {
        name: 'Requested',
        color: '#F6F7F9',
        id: uuid(),
        items: [
          { id: uuid(), topic: 'First task' },
          { id: uuid(), topic: 'Second task' },
        ],
      },
      {
        name: 'To do',
        color: '#FEEFED',
        id: uuid(),
        items: [],
      },
      {
        name: 'In Progress',
        color: '#FFF7D6',
        id: uuid(),
        items: [],
      },
      {
        name: 'Done',
        color: '#DFF8E3',
        id: uuid(),
        items: [],
      },
      {
        name: 'Testing',
        color: '#DFF8E3',
        id: uuid(),
        items: [],
      },
    ];
  },
};
